"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var react_1 = __importDefault(require("react"));
var TimelineControls_1 = __importDefault(require("./TimelineControls"));
var TimelineLine_1 = __importDefault(require("./TimelineLine"));
var EventType;
(function (EventType) {
    EventType["MOVING"] = "moving";
    EventType["IDLE"] = "idle";
    EventType["OFF"] = "off";
    EventType["SAFETY_EVENT"] = "safety_event";
})(EventType = exports.EventType || (exports.EventType = {}));
var Timeline = function (props) {
    var events = props.events, onChange = props.onChange;
    var _a = __read(react_1.default.useState(0), 2), seekPosition = _a[0], setSeekPosition = _a[1];
    var _b = __read(react_1.default.useState(0.5), 2), zoom = _b[0], setZoom = _b[1];
    var updatePosition = function (position) {
        setSeekPosition(position);
    };
    return (react_1.default.createElement("div", { className: "timeline" },
        react_1.default.createElement(TimelineControls_1.default, { zoom: zoom, onZoomChange: setZoom, position: seekPosition, updatePosition: updatePosition }),
        react_1.default.createElement(TimelineLine_1.default, { zoom: zoom, events: events, onSelectedRange: onChange, onChange: setSeekPosition, position: seekPosition })));
};
exports.default = Timeline;
